// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/" + chunkId + "." + chunkId + "." + {"3691":"85a91e8c","5413":"325c9e3d","5580":"86c9263d","8847":"f5cdd6ae"}[chunkId] + ".css";
};